
import React from "react";
import { checkSession, getBrand, setFavicon} from "../lib/functions"
import Header from "./Header.js";
import Login from "./Login.js";
import FadeIn from "./Fadein.js";
import Main from "./Main.js";
import { Fragment } from "react";

export default class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn : false, 
      brand : {}, 
      sessionChecked : false,
      student: ""
    }
  }

  
  componentDidMount = () =>  {
    const brand = getBrand();
    this.setState({brand: brand});
      checkSession((data) =>  {

        let valid = data.valid;
        
        this.setState({loggedIn : valid, sessionChecked : true});
        if(valid) this.setState({student: data});
     
      });
    setFavicon(brand.favicon);
  }

  loggedIn = (student) => {
    this.setState({loggedIn : true, student : student});
  }

  render() {
         return (      
          <Fragment>

            {!this.state.loggedIn && this.state.sessionChecked  ? 
                <>
                  <Header student={this.state.student}/>
                  <FadeIn>
                    <Login loggedIn={this.loggedIn}/> 
                  </FadeIn>
                </>
                  : null
            } 
            {this.state.loggedIn && this.state.sessionChecked ? 
                  <Main student={this.state.student}/>
            : null }
          </Fragment>
         )
   }
}